import React, { useEffect, useState, useContext } from "react";
import useStyles from "./styles";
import { useTranslation } from 'react-i18next';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { PaymentModes } from '../../../utils/index';
import { Typography } from "@material-ui/core";
import ErrorMessages from "../../ErrorMessages";
import axios from "../../../api/axios";
import { EncryptedPubKey } from '../../../App';

const style = {"layout":"horizontal"};

const PayPal = ({ currentPaymentSystem, formik, errorString, paymentInfo }) => {
  const [error, setError] = useState('');
  const classes = useStyles();
  const { t } = useTranslation();
  const isAuthOnly = paymentInfo?.type === PaymentModes.Authorize;
  const [deferLoading, setDeferLoading] = useState(false);
  const encryptedPubKey = useContext(EncryptedPubKey);
  const [initialOptions, setInitialOptions] = useState({
    clientId: null,
    merchantId: null,
    currency: null,
    intent: null,
    dataPartnerAttributionId: null,
  });

  useEffect(() => {
    updateOptions();
    setDeferLoading(true);
  }, [formik, currentPaymentSystem, paymentInfo]);

  useEffect(() => {
    if (errorString) {
      setError(errorString);
    }
  }, [errorString]);

  const updateOptions = () => {
    if (!currentPaymentSystem.externalMerchantId) {
      return;
    }
    const payPalOptions = JSON.parse(currentPaymentSystem.externalMerchantId);
    const initialOptions = {
      clientId: payPalOptions.clientId,
      merchantId: payPalOptions.merchantId,
      currency: currentPaymentSystem?.currencyToPay,
      intent: isAuthOnly ? 'authorize' : 'capture',
      commit: !isAuthOnly,
      dataPartnerAttributionId: payPalOptions.attributionId,
    };
    setInitialOptions(initialOptions);
  }

  const createOrder = (data, actions) => {
    const payload = {
      currency: currentPaymentSystem?.currencyToPay,
      items: [
        {
          name: paymentInfo?.description || paymentInfo?.transactionId,
          unitprice: (currentPaymentSystem?.amountToPay || 0).toString(),
          quantity: 1,
        }
      ]
    };
    const orderPayload = {
      pubKey: encryptedPubKey,
      countryIso: formik.values.country || paymentInfo?.defaultCountry,
      brandCode: currentPaymentSystem.code,
			payload: JSON.stringify(payload),
			capture: !isAuthOnly,
      isPaymentContext: true,
    }
    const promise = axios.patch('/lpm', orderPayload, {
      headers: {
        'X-ApiKey': paymentInfo.merchantPubKey
      }
    });

    const dataPromise = promise.then((response) => response.data?.orderId);
    return dataPromise;
  }

  const onApprove = (data, actions) => {
    const payload = {
      billingToken: data.billingToken,
      payerID: data.payerID,
      orderID: data.orderID,
      paymentID: data.paymentID,
      paymentSource: data.paymentSource,							
    };
    formik.setFieldValue('metadata', payload);

    return Promise.resolve().then(() => formik.submitForm());
  }

  return (
    <div className={classes.wrapper}>
      {error && (
        <ErrorMessages errorString={error} />
      )}
      <Typography align="center" className={classes.error} gutterBottom>
        {currentPaymentSystem?.warningMessage}
      </Typography>
      {deferLoading && (
        <PayPalScriptProvider options={initialOptions}>
          <PayPalButtons
            fundingSource='paypal'
            style={style}
            disabled={false}
            forceReRender={[style]}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={(err) => setError(err)}
          />
        </PayPalScriptProvider>
      )}
    </div>
  )
};

export default PayPal
